export const useSiteLinks = ( templateId ) => {
	if ( ! AstraShowcaseVars ) {
		return;
	}
	const sites = Object.values( AstraShowcaseVars?.sites );

	// find the site by id
	// eslint-disable-next-line
	const selectedSite = sites?.find( ( site ) => site?.id == templateId );

	// eslint-disable-next-line
	console.log( selectedSite ); // ToDO- Remove before release.
	// var to store links of the avaible builders
	const sitesLinks = {};

	const beaverBuilderTemplateId = selectedSite?.[ 'related-bb-template' ],
		gutenbergTemplateId = selectedSite?.[ 'related-gutenberg-template' ],
		elementorTemplateId = selectedSite?.[ 'related-elementor-template' ];

	if ( beaverBuilderTemplateId ) {
		const beaverBuilderTemplateLink = sites?.find(
			// eslint-disable-next-line
			( site ) => site?.id == beaverBuilderTemplateId
		);

		sitesLinks[ 'beaver-builder' ] =
    beaverBuilderTemplateLink?.[ 'astra-site-live-url' ] || beaverBuilderTemplateLink?.[ 'astra-site-url' ];
	}

	if ( gutenbergTemplateId ) {
		const gutenbergTemplateLink = sites?.find(
			// eslint-disable-next-line
			( site ) => site?.id == gutenbergTemplateId
		);

		sitesLinks.gutenberg =
    gutenbergTemplateLink?.[ 'astra-site-live-url' ] || gutenbergTemplateLink?.[ 'astra-site-url' ];
	}

	if ( elementorTemplateId ) {
		const elementorTemplateLink = sites?.find(
			// eslint-disable-next-line
			( site ) => site?.id == elementorTemplateId
		);

		sitesLinks.elementor =
    elementorTemplateLink?.[ 'astra-site-live-url' ] || elementorTemplateLink?.[ 'astra-site-url' ];
	}

	return sitesLinks;
};
